
<template>
  <!-- 招聘岗位 -->
  <div>
    <el-dialog title="招聘岗位" :visible.sync="dialogTableVisible" append-to-body>
      <div class="query-form">
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="80px"
        >
          <el-row :gutter="24">
            <el-col :span="8" >
              <el-form-item
                label="专业"
                prop="zylb"
              >
                <el-input
                  v-model="form.zylb"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" >
              <el-form-item
                label="招聘单位"
                prop="ssbk"
              >
                <el-input
                  v-model="form.ssbk"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            style="display: flex; justify-content: flex-end; align-items: center"
          >
            <el-col :span="2" :offset="18">
              <el-button type="primary" size="small" @click="getInfo">查询</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="info" size="small" @click="clear">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table height="350" border :data="gridData"
        @sort-change="handleSortChange"
        :header-cell-class-name="handleHeadAddClass"
      >
        <el-table-column
          property="zylb"
          label="专业"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          property="jhrs"
          label="招聘人数"
        ></el-table-column>
        <el-table-column
          property="ssbk"
          label="招聘单位"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          property="gzdd"
          label="工作地点"
        ></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" @click="choice(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <pagination :total="pagination.total" 
          @currentPageChange="currentPageChange" 
          @pageSizeChange="pageSizeChange"
          :pageSizes="pageSizes">
        </pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/api/postList.js";
import pagination from "@/components/pagination.vue";

let cols = [];
export default {
  props: ['zplb'],
  components: {
    pagination
  },
  data() {
    return {
      gridData: [],
      sortField: {},
      orderBys: [], //存储排序信息
      form: {
        zylb: "",
        ssbk: "",
      },
      dialogTableVisible: false,
      zphdid: "",
      pagination: {
        total: 0,
        pageSize: 10,
        page: 1,
      },
      pageSizes: [10, 30, 50, 100],
    };
  },
  watch: {
    dialogTableVisible() {
      if(this.dialogTableVisible){
        this.getInfo()
      }
    },
  },
  methods: {
    open(data) {
      this.form.zylb = data.keyword;
      this.zphdid = data.zphdid;
      this.dialogTableVisible = true;
    },
    close() {
      this.dialogTableVisible = false;
    },
    //排序方法
    async handleSortChange({ order, prop }) {
      this.orderPage = order;
      this.propPage = prop;
      // 触发的排序和缓存的排序相同时，取消该字段的排序
      if (!order || this.sortField[prop] === order) {
          this.sortField[prop] = null;
      } else {
          this.sortField[prop] = order;
      }
      console.log("对象存储数据>>>>>", this.sortField);

      this.orderBys = [];

      let direction = "";
      for (var i in this.sortField) {
          if (this.sortField[i] == "ascending") {
              direction = "ASC";
          } else if (this.sortField[i] == "descending") {
              direction = "DESC";
          } else {
              direction = "";
          }

          this.orderBys.push({
              column: i,
              direction: direction,
          });
      }

      this.getInfo();
    },

    handleHeadAddClass({ column }) {
        cols.push(column); //重置使用数组
        if (this.sortField[column.property]) {
            column.order = this.sortField[column.property];
        }
    },
    clear(){
      this.form.zylb = "";
      this.form.ssbk = "";

      this.pagination.page = 1;
      this.pagination.pageSize = 10;
      this.pagination.total = 0;
      this.gridData = [];
      this.sortField = {};
      this.orderBys = [];
      cols.forEach((col) => {
          col.order = "";
      });
    },
    pageSizeChange(e) {
      this.pagination.pageSize = e;
      this.pagination.page = 1;
      this.getInfo();
    },
    currentPageChange(e) {
      this.pagination.page = e;
      this.getInfo();
    },
    /* 获取信息 */
    async getInfo() {
      var orderInfo = JSON.stringify(this.orderBys);
      const para = {
        gwlbmc: this.form.zylb,
        ssbk: this.form.ssbk,
        zphdid: this.zphdid,
        zplb: this.zplb,
        page: this.pagination.page, //页码
        pageSize: this.pagination.pageSize, //每页显示的条数
        orderInfo: orderInfo,
      };
      const data = await request.queryZpgw(para);
      this.gridData = data.vds.map((item)=>{
        return {
            ...item,
        }

      });
      this.pagination.total = data.total;
    },
    /* 选择 */
    choice(data) {
      this.$emit("choiceData", data);
      this.dialogTableVisible = false;
    },
  },
};
</script>

<style>
.query-form {
  transition: display 0.5s;
}
</style>